import { usePM2DisplayContext } from '@pm2/store';
import { AudioPlayerToggler } from './audio-player/_toggler.js';
import { ToolbarDropdown } from './dropdown/_dropdown.js';
import { isSupportedComponentNode } from './typings.component-nodes.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function ElementToolbar(props) {
  const {
    inLibrary
  } = usePM2DisplayContext();
  const isComponentFrameworkNode = props.node.nodeType.startsWith("component-framework.");
  if (!isSupportedComponentNode(props.node)) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!isComponentFrameworkNode && /*#__PURE__*/jsx(AudioPlayerToggler, {
      inLibrary: inLibrary,
      audioFile: props.node.pm2.speechFileUrl
    }), /*#__PURE__*/jsx(ToolbarDropdown, {
      node: props.node,
      customPosition: props.customPosition
    })]
  });
}

export { ElementToolbar };
//# sourceMappingURL=element-toolbar.js.map
